(function($) {
    // Setup custom homepage slider
    $(document).on('ready', function() {
        $('.scrolling-columns').each(function() {
            setSpeed($(this));
        });
    });
    $(window).on('resize', function() {
        $('.scrolling-columns').each(function() {
            setSpeed($(this));
        });
    });

    function setSpeed(slider) {
        // get the width of the slider group and set the animation speed based off the perPixel variable
        var perPixel = 50; // Speed in pixels per second

        if($(window).width() < 992) {
            perPixel = 30;
        }

        var $sliderGroup = slider.find('.slider-group'),
            sliderHeight = $sliderGroup.height(),
            sliderWidth = $sliderGroup.width(),
            animationSpeedHeight = sliderHeight / perPixel * 1000,
            animationSpeedWidth = sliderWidth / perPixel * 1000;

        
        // Set the animation speed
        if($(window).width() < 992) {
            $sliderGroup.css('animation-duration', animationSpeedWidth + 'ms');
        } else {
            $sliderGroup.css('animation-duration', animationSpeedHeight + 'ms');
        }
    }
}(jQuery));
